"use client"
import Lottie from "src/orca/components/Lottie/Lottie"

const Loading = () => (
  <div className="h-screen w-screen flex justify-center items-center absolute top-0 left-0 bg-tokens-surface-background-bg-primary">
    <div className="w-tokens-width-128">
      <Lottie filename="po-logo" />
    </div>
  </div>
)

export default Loading
